const formatBookDescription = (htmlString: string) => {
  const el = document.createElement('div')
  el.innerHTML = htmlString

  return el.innerText
}

export default formatBookDescription
